<template lang="pug">
  .zeus-dashboard
    zeus-header(ref="zeus")
    DynamicMedia.main-container-fluid(:config="{src: '/Gym%20Builder/hero-image-4k_aga2cd.jpg', alt:'Zeus', width:3840, height:1334}")
    .tabs-container.zeus-dashboard-container.main-container-wide
      Tabs(:modelValue="$route.name" @update:modelValue="changeTab($event)" :tabs="['Featured Gyms', 'Room Templates', 'My Gyms']")
      RogueButton(size='s' link="/zeus-builder/project/edit?templateId=new") {{ __('Create New Gym', 'zeus') }}
      router-view.tab-content.zeus-dashboard-container
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { useRoute, useRouter } from 'vue-router'
import zeusHeader from './components/header.vue'
import { useRogue } from '@/js/services/Rogue'
import metadata from '@/js/helpers/metadata'

const route = useRoute()
const router = useRouter()
const rogue = useRogue()

useHead(metadata({
  title         : rogue.__('ZEUS Gym Builder by Rogue Fitness | Design Your Dream Gym Layout'),
  description   : rogue.__('ZEUS Gym Builder is Rogue Fitness\'s interactive layout tool that lets you build your dream gym space using real Rogue equipment. Log in to start planning your home gym or custom facility today.'),
  titleTemplate : rogue.__('ZEUS Gym Builder by Rogue Fitness | Design Your Dream Gym Layout'),
}, rogue))

function changeTab(tab: string) {
  if (tab === route.name) {
    return
  }
  if (tab === 'My Gyms') {
    router.push('/zeus-builder/my-gyms')
  } else if (tab === 'Room Templates') {
    router.push('/zeus-builder/templates')
  } else {
    router.push('/zeus-builder')
  }
}
</script>
<style lang="scss">
/*
Unscoped styles that apply to all child routes
 */

.zeus-dashboard-container {
  .blurb {
    margin: $space-l 0;
    font-size: $size-xs;
  }

  @include mobile() {
    .tab-title:nth-child(2) {
      display: none;
    }
  }

  .gym {
    cursor: pointer;
    border: 1px solid $color-gray-light;
    border-radius: $radius-default;
    padding-bottom: $space-xs;

    .title, .subtitle, .cta-links {
      margin-left: $space-xs;
      margin-right: $space-xs;
    }
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    gap: $space-xs;
    margin-bottom: $space-s;

    @include tablet() {
      grid-template-columns: 50% 50%;
    }

    @include all-desktop() {
      grid-template-columns: 25% 25% 25% 25%;
    }
  }
}
</style>

<style lang="scss" scoped>
.hero {
  width: 100%;
  margin-bottom: $space-m;
}

.tabs-container {
  position: relative;
  margin-top: $space-s;

  > .button {
    position: absolute;
    right: 0;
    top: 0;

    @include mobile() {
      display: none;
    }
  }
}

</style>
